// @flow

import React from 'react';
import {Icon} from 'react-fa';

import type {Element} from 'react';

import './css/Wait.css';


type T_WaitProps = {
  small?: boolean
};


export default function Wait(props: T_WaitProps): Element<string> {
  const size = {};
  
  if (! props.small) {
    size.size = '3x';
  }
  
  return (
    <div className='wait' style={{marginTop: props.small ? 20 : 30}}>
      <Icon name='spinner' spin={true} pulse={true} {...size} />
      
      {(! props.small) && 
        <p>
          Espere…
        </p>
      }
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/Wait.jsx